import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React, { useEffect } from 'react';
import "./App.css";
import Home from "./pages/home/Home";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import TopButton from "./components/topButton/TopButton";
import ContactPage from "./pages/contact/ContactPage";
import AboutPage from "./pages/about/AboutPage";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";
// import ServicesPage from "./pages/services/ServicesPage";
import InvestorPage from "./pages/investor/InvestorPage";
import IncentivesPage from "./pages/sustainability/IncentivesPage";
import { useTranslation } from 'react-i18next';

function App() {

  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          {/* <Route path="/services" element={<ServicesPage />} /> */}
          <Route path="/investment-opportunities" element={<InvestorPage />} />
          <Route path="/investment-incentives" element={<IncentivesPage />} />
        </Routes>
        <Footer />
        <TopButton />
      </Router>
    </div>
  );
}

export default App;